<template>
  <div style="overflow: hidden">
    <div class="listingpush" />

    <section class="cat_product_area">
      <div class="container conlist">
        <div class="flex-row-reverse">
          <!-- Ana İçerik Alanı -->
          <div
            id="petListingDiv"
            class="col-lg-12 petnofilter"
          >
            <!-- Loading Spinner -->
            <div
              v-show="loading"
              class="loading"
            >
              <LoadingSpinner />
              <p>Loading...</p>
            </div>
            <div
              v-if="error"
              class="error"
            >
              {{ error }}
            </div>

            <!-- Breadcrumb -->
            <div
              class="row text-center"
              style="font-size: 12px"
            >
              <div class="banner_content">
                <div class="page_link breadc">
                  <a
                    href="javascript:void(0)"
                    @click="$router.push('/')"
                  >Home </a>
                  <a href="" />
                  <a
                    href="javascript:void(0)"
                    @click="$router.go(-1)"
                  >Go Back</a>
                </div>
              </div>
            </div>
            <div class="product_top_bar lst-drps">
              <div class="flex-wrap">
                <div class="center_drop sort-controls">
                  <select
                    v-model="selectedCategory"
                    @change="changeCategory"
                  >
                    <option value="null">
                      All Categories
                    </option>
                    <template
                      v-for="category in categories"
                      :key="category.id"
                    >
                      <option
                        v-if="petCounts[`count_${category.name}`] > 0"
                        :value="category.name"
                      >
                        {{ category.name }} ({{ petCounts[`count_${category.name}`] }})
                      </option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="right_page ml-auto msifir">
                <ul
                  class="search-title-tab-list"
                  style="margin: unset"
                >
                  <li>
                    <router-link
                      to="/petmapview"
                      class="pet-listing-view-control-btn"
                      style="row-gap: 0px; font-size: 30px; border: none; width: unset"
                    >
                      <i
                        class="icon-map"
                        style="font-size: 40px"
                      />
                      <span style="font-size: 12px">Map View</span>
                    </router-link>
                  </li>

                  <li>
                    <a
                      href="#"
                      class="pet-listing-view-control-btn"
                      style="row-gap: 0px; font-size: 30px; border: none; width: unset"
                      @click.prevent="changeCardView"
                    >
                      <i
                        :class="cardView === 'grid' ? 'icon-icons2' : 'icon-menu2'"
                        style="font-size: 40px"
                      />
                      <span style="font-size: 12px">Change View</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Pet Listings -->
            <div
              v-if="catListings.length"
              class="latest_product_inner"
            >
              <div id="bilgin">
                <!-- Cats -->
                <div>
                  <div
                    class="section-title section-title-dk-blue fl-wrap"
                    style="width: 100%; position: relative"
                  >
                    <h2 style="text-align: start">
                      <span>Cats</span>
                    </h2>
                    <div
                      class="section-subtitle"
                      style="text-align: start"
                    >
                      Cats
                    </div>
                    <router-link
                      to="/pets?category=Cats"
                      style="position: absolute; right: 0; top: 15px; font-size: 15px; font-weight: 400; color: #2d0505; z-index: 10; text-decoration: none;"
                    >
                      View All ►
                    </router-link>
                  </div>
                  <Carousel
                    :items-to-show="itemsToShow"
                    :autoplay="2950"
                    :wrap-around="true"
                    :mouse-wheel="true"
                    snap-align="start"
                  >
                    <Slide
                      v-for="pet in catListings"
                      :key="pet.id"
                    >
                      <div class="dik">
                        <router-link
                          :to="`/pets/${pet.id}`"
                          class="pet-link"
                        >
                          <div class="pet-link">
                            <div :class="['card', { 'boosted': pet.boosted, 'gradient-border': pet.boosted }]">
                              <div class="card-header justify-content-between">
                                <span
                                  class="col"
                                  style="font-size: 11.6px"
                                ><i>{{ pet.category }}/{{ pet.subCategory }}</i></span>
                                <span
                                  v-if="pet.boosted"
                                  class="col boostabso"
                                  style="font-size: 11.6px"
                                >
                                  <a class="animtext"><i class="icon-diamond2" /> Boosted
                                    <i class="icon-diamond2" /></a>
                                </span>
                              </div>
                              <div class="hor-var">
                                <div class="f_p_item resim_ana_d pricing-section">
                                  <div class="ribbon">
                                    <span>{{ pet.adType }}</span>
                                  </div>
                                  <span class="resim_spa">
                                    <div class="f_p_img resim_d">
                                      <div
                                        v-if="pet.coverImage"
                                        class="cover-image"
                                      >
                                        <img
                                          class="img-fluid resim rounded"
                                          :src="pet.coverImage"
                                          alt="Cover Image"
                                        >
                                      </div>
                                      <div
                                        v-else
                                        class="cover-image"
                                      >
                                        <img
                                          class="img-fluid resim"
                                          src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media"
                                          alt="Cover Image"
                                        >
                                      </div>
                                    </div>
                                  </span>
                                </div>
                                <div class="card-body">
                                  <h5 class="price_h5">
                                    £{{ pet.price }}
                                  </h5>
                                  <h6 class="card-title">
                                    {{ pet.title }}
                                  </h6>
                                  <h6
                                    v-if="pet.sellerType === 'individual'"
                                    class="user-reg"
                                  >
                                    <i
                                      class="icon-clipboard-empty"
                                      style="font-size: 20px; color: #c5322d; padding-left: 10px"
                                    />
                                    Individual
                                  </h6>
                                  <h6
                                    v-if="pet.premium"
                                    class="user-reg"
                                  >
                                    <i
                                      class="icon-crown"
                                      style="font-size: 20px; color: #c5322d; padding-left: 10px"
                                    />
                                    Premium
                                  </h6>
                                </div>
                                <div class="card-footer">
                                  <span
                                    class="text-muted age text-end mb-0"
                                    style="font-size: smaller; float: right"
                                  >
                                    {{ calculateAgeInWeeks(pet.birthDate) }} old
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </Slide>
                  </Carousel>
                </div>
                <!-- Cats END-->
                <!-- Dogs -->
                <div>
                  <div
                    class="section-title section-title-dk-blue fl-wrap"
                    style="width: 100%; position: relative"
                  >
                    <h2 style="text-align: start">
                      <span>Dogs</span>
                    </h2>
                    <div
                      class="section-subtitle"
                      style="text-align: start"
                    >
                      Dogs
                    </div>
                    <router-link
                      to="/pets?category=Dogs"
                      style="position: absolute; right: 0; top: 15px; font-size: 15px; font-weight: 400; color: #2d0505; z-index: 10; text-decoration: none;"
                    >
                      View All ►
                    </router-link>
                  </div>
                  <Carousel
                    :items-to-show="itemsToShow"
                    :autoplay="2800"
                    :wrap-around="true"
                    :mouse-wheel="true"
                    snap-align="start"
                  >
                    <Slide
                      v-for="pet in dogListings"
                      :key="pet.id"
                    >
                      <div class="dik">
                        <router-link
                          :to="`/pets/${pet.id}`"
                          class="pet-link"
                        >
                          <div class="pet-link">
                            <div :class="['card', { 'boosted': pet.boosted, 'gradient-border': pet.boosted }]">
                              <div class="card-header justify-content-between">
                                <span
                                  class="col"
                                  style="font-size: 11.6px"
                                ><i>{{ pet.category }}/{{ pet.subCategory }}</i></span>
                                <span
                                  v-if="pet.boosted"
                                  class="col boostabso"
                                  style="font-size: 11.6px"
                                >
                                  <a class="animtext"><i class="icon-diamond2" /> Boosted
                                    <i class="icon-diamond2" /></a>
                                </span>
                              </div>
                              <div class="hor-var">
                                <div class="f_p_item resim_ana_d pricing-section">
                                  <div class="ribbon">
                                    <span>{{ pet.adType }}</span>
                                  </div>
                                  <span class="resim_spa">
                                    <div class="f_p_img resim_d">
                                      <div
                                        v-if="pet.coverImage"
                                        class="cover-image"
                                      >
                                        <img
                                          class="img-fluid resim rounded"
                                          :src="pet.coverImage"
                                          alt="Cover Image"
                                        >
                                      </div>
                                      <div
                                        v-else
                                        class="cover-image"
                                      >
                                        <img
                                          class="img-fluid resim"
                                          src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media"
                                          alt="Cover Image"
                                        >
                                      </div>
                                    </div>
                                  </span>
                                </div>
                                <div class="card-body">
                                  <h5 class="price_h5">
                                    £{{ pet.price }}
                                  </h5>
                                  <h6 class="card-title">
                                    {{ pet.title }}
                                  </h6>
                                  <h6
                                    v-if="pet.sellerType === 'individual'"
                                    class="user-reg"
                                  >
                                    <i
                                      class="icon-clipboard-empty"
                                      style="font-size: 20px; color: #c5322d; padding-left: 10px"
                                    />
                                    Individual
                                  </h6>
                                  <h6
                                    v-if="pet.premium"
                                    class="user-reg"
                                  >
                                    <i
                                      class="icon-crown"
                                      style="font-size: 20px; color: #c5322d; padding-left: 10px"
                                    />
                                    Premium
                                  </h6>
                                </div>
                                <div class="card-footer">
                                  <span
                                    class="text-muted age text-end mb-0"
                                    style="font-size: smaller; float: right"
                                  >
                                    {{ calculateAgeInWeeks(pet.birthDate) }} old
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </Slide>
                  </Carousel>
                </div>
                <!-- Dogs END-->
                <!-- others -->
                <div>
                  <div
                    class="section-title section-title-dk-blue fl-wrap"
                    style="width: 100%; position: relative"
                  >
                    <h2 style="text-align: start">
                      <span>Other Categories</span>
                    </h2>
                    <div
                      class="section-subtitle"
                      style="text-align: start"
                    >
                      Other Categories
                    </div>

                    <div
                      class="section-subtitle"
                      style="
                        text-align: end;
                        cursor: pointer;
                        font-size: 15px;
                        font-weight: 400;
                        color: #2d0505;
                        top: 5px;
                        left: -30px;
                      "
                    />
                  </div>
                  <Carousel
                    :items-to-show="itemsToShow"
                    :autoplay="3000"
                    :wrap-around="true"
                    :mouse-wheel="true"
                    snap-align="start"
                  >
                    <Slide
                      v-for="pet in allListings"
                      :key="pet.id"
                    >
                      <div class="dik">
                        <router-link
                          :to="`/pets/${pet.id}`"
                          class="pet-link"
                        >
                          <div class="pet-link">
                            <div :class="['card', { 'boosted': pet.boosted, 'gradient-border': pet.boosted }]">
                              <div class="card-header justify-content-between">
                                <span
                                  class="col"
                                  style="font-size: 11.6px"
                                ><i>{{ pet.category }}/{{ pet.subCategory }}</i>
                                </span>
                                <span
                                  v-if="pet.boosted"
                                  class="col boostabso"
                                  style="font-size: 11.6px"
                                >
                                  <a class="animtext"><i class="icon-diamond2" /> Boosted
                                    <i class="icon-diamond2" /></a>
                                </span>
                              </div>
                              <div class="hor-var">
                                <div class="f_p_item resim_ana_d pricing-section">
                                  <div class="ribbon">
                                    <span>{{ pet.adType }}</span>
                                  </div>
                                  <span class="resim_spa">
                                    <div class="f_p_img resim_d">
                                      <div
                                        v-if="pet.coverImage"
                                        class="cover-image"
                                      >
                                        <img
                                          class="img-fluid resim rounded"
                                          :src="pet.coverImage"
                                          alt="Cover Image"
                                        >
                                      </div>
                                      <div
                                        v-else
                                        class="cover-image"
                                      >
                                        <img
                                          class="img-fluid resim"
                                          src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media"
                                          alt="Cover Image"
                                        >
                                      </div>
                                    </div>
                                  </span>
                                </div>
                                <div class="card-body">
                                  <h5 class="price_h5">
                                    £{{ pet.price }}
                                  </h5>
                                  <h6 class="card-title">
                                    {{ pet.title }}
                                  </h6>
                                  <h6
                                    v-if="pet.sellerType === 'individual'"
                                    class="user-reg"
                                  >
                                    <i
                                      class="icon-clipboard-empty"
                                      style="font-size: 20px; color: #c5322d; padding-left: 10px"
                                    />
                                    Individual
                                  </h6>
                                  <h6
                                    v-if="pet.premium"
                                    class="user-reg"
                                  >
                                    <i
                                      class="icon-crown"
                                      style="font-size: 20px; color: #c5322d; padding-left: 10px"
                                    />
                                    Premium
                                  </h6>
                                </div>
                                <div class="card-footer">
                                  <span
                                    class="text-muted age text-end mb-0"
                                    style="font-size: smaller; float: right"
                                  >
                                    {{ calculateAgeInWeeks(pet.birthDate) }} old
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </Slide>
                  </Carousel>
                </div>
                <!-- others END-->
              </div>
            </div>

            <!-- Loading ve No Data durumları -->
            <div
              v-if="loading"
              class="bottom-loading"
            >
              <LoadingSpinner />
            </div>

            <div
              v-if="!loading && !catListings.length"
              class="no-data"
            >
              No Ads Found ...
            </div>

            <div
              v-if="loading && !catListings.length"
              class="loading"
            >
              <LoadingSpinner />
              <p>Loading...</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      v-if="showModal"
      class="pet-modal animate__animated"
      :class="{ animate__slideInRight: showPopup, animate__slideOutRight: !showPopup }"
      @animationend="handleModalAnimation"
    >
      <button
        class="close-button animate__animated animate__shakeY"
        @click="closeModal"
      >
        Close
      </button>
      <div class="pet-modal-content">
        <PetDetails />
      </div>
    </div>
  </div>
</template>

<script setup>
  import PetDetails from '@/components/PetDetails.vue';
  import { ref, watch, onMounted, defineProps } from 'vue';
  import { useRouter } from 'vue-router';

  import { collection, query, getDocs, where, orderBy, limit, doc, getDoc } from 'firebase/firestore';
  import { db } from '@/firebase/index.js';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  // Yardımcı fonksiyonlar
  import { calculateAgeInWeeks } from '@/utils/dateUtils';

  defineProps({
    pet: Object,
  });
  import { Carousel, Slide } from 'vue3-carousel';
  import 'vue3-carousel/dist/carousel.css';
  import { computed, onBeforeUnmount } from 'vue';

  // Ekran genişliğini takip eden değişken
  const screenWidth = ref(window.innerWidth);

  // Resize event'i dinleyerek ekran genişliğini güncelle
  const updateScreenWidth = () => {
    screenWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener('resize', updateScreenWidth);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  // Ekran genişliğine göre items-to-show değerini belirle
  const itemsToShow = computed(() => {
    if (screenWidth.value > 1200) return 6; // 1024px üstü → 6 öğe
    if (screenWidth.value > 768) return 4; // 768px - 1024px → 4 öğe
    return 2; // 768px altı → 2 öğe
  });
  const router = useRouter();
  const error = ref(null);
  const loading = ref(false);

  const catListings = ref([]);
  const dogListings = ref([]);
  const allListings = ref([]);
  //const totalCount = ref(0);
  const cardView = ref(localStorage.getItem('preferred_view') || 'grid');
  const categories = ref([]);
  const petCounts = ref({});
  const selectedCategory = ref(null);

  // Kategori verilerini bir kez çek ve tüm işlemlerde kullan
  const fetchCategoriesAndData = async () => {
    try {
      loading.value = true;

      // 1. Önce kategorileri getir
      const categoriesRef = collection(db, 'petcategories');
      const q = query(categoriesRef, orderBy('order', 'asc'));
      const querySnapshot = await getDocs(q);

      categories.value = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Fetch pet counts from metadata
      const countsDoc = await getDoc(doc(db, 'metadata', 'petCounts'));
      if (countsDoc.exists()) {
        petCounts.value = countsDoc.data();
      }

      // 2. Kategori verilerini kullanarak tüm sorguları parallel yap
      const [catResult, dogResult, otherResult] = await Promise.all([
        fetchListingsForCategory('Cats'),
        fetchListingsForCategory('Dogs'),
        fetchListingsForOtherCategories(),
      ]);

      catListings.value = catResult;
      dogListings.value = dogResult;
      allListings.value = otherResult;
    } catch (err) {
      console.error('Error loading data:', err);
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  // Generic fonksiyon - tek bir kategori için ilan getir
  const fetchListingsForCategory = async (categoryName) => {
    const petsRef = collection(db, 'pets');

    const normalQuery = query(
      petsRef,
      where('status', '==', 'active'),
      where('category', '==', categoryName),
      orderBy('createdAt', 'desc'),
      limit(20) // Fetch up to 20 recent ads to sort by boost locally
    );

    const snapshot = await getDocs(normalQuery);
    let listings = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // JavaScript'te boosted olanları başa alacak şekilde sırala
    listings.sort((a, b) => (b.boosted || 0) - (a.boosted || 0));

    // İlk 6 ilanı döndür
    return listings.slice(0, 6);
  };

  // Diğer kategoriler için ilan getir
  const fetchListingsForOtherCategories = async () => {
    // Cats ve Dogs dışındaki kategorileri filtrele
    const otherCategories = categories.value
      .filter((cat) => cat.name !== 'Cats' && cat.name !== 'Dogs')
      .map((cat) => cat.name);

    if (otherCategories.length === 0) {
      return [];
    }

    // Firestore sorguları için kategori sayısı kontrolü
    // Firestore WHERE IN sorguları max 10 eleman alabilir
    const categoryBatches = [];
    for (let i = 0; i < otherCategories.length; i += 10) {
      categoryBatches.push(otherCategories.slice(i, i + 10));
    }

    // Her kategori grubu için ayrı sorgu yap ve sonuçları birleştir
    let allListings = [];

    for (const batch of categoryBatches) {
      const normalQuery = query(
        collection(db, 'pets'),
        where('status', '==', 'active'),
        where('category', 'in', batch),
        orderBy('createdAt', 'desc'),
        limit(20)
      );

      const snapshot = await getDocs(normalQuery);
      allListings.push(...snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    }

    // Sort by boosted locally and return top 6
    allListings.sort((a, b) => (b.boosted || 0) - (a.boosted || 0));
    
    return allListings.slice(0, 6);
  };
  // Modal kontrolleri için state'ler
  const showModal = ref(false);
  const showPopup = ref(false);
  const scrollPosition = ref(0);

  // Modal'ı kapatma fonksiyonu
  const closeModal = () => {
    showPopup.value = false; // Önce animasyonu başlat
  };

  // Animasyon bittiğinde çalışacak fonksiyon
  const handleModalAnimation = (event) => {
    if (event.animationName === 'slideOutRight' && !showPopup.value) {
      showModal.value = false; // Animasyon bittiğinde modal'ı DOM'dan kaldır
    }
  };

  onMounted(async () => {
    await fetchCategoriesAndData();
  });

  // Modal açıldığında/kapandığında scroll durumunu kontrol et
  watch(showModal, (isOpen) => {
    if (isOpen) {
      // Mevcut scroll pozisyonunu kaydet
      scrollPosition.value = window.scrollY;
      // Body'yi sabitle
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      // Body stillerini temizle
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    }
  });

  const changeCategory = () => {
    if (selectedCategory.value && selectedCategory.value !== 'null') {
      router.push(`/pets?category=${selectedCategory.value}`);
    } else {
      router.push('/pets');
    }
  };
</script>

<style scoped>
  @media (min-width: 992px) {
    .listingpush {
      min-height: 75px;
    }
  }

  @media (min-width: 1200px) {
    .listingpush {
      min-height: 150px;
    }
  }

  /* Modal stilleri */
  .pet-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow: hidden;
    touch-action: pan-y;
    animation-duration: 0.5s !important;
    -webkit-overflow-scrolling: touch;
  }

  .pet-modal-content {
    background: white;
    border-radius: 0;
    padding: 0;
    max-width: 100%;
    max-height: 100vh;
    overflow: auto;
  }

  .animate__animated {
    --animate-duration: 0.5s;
  }

  .close-button {
    position: fixed;
    top: 0;
    left: calc(50% - 55px);
    border: rgb(255, 255, 255);
    border-style: solid;
    font-size: 20px;
    cursor: pointer;
    z-index: 11001;
    animation-duration: 1s;
    animation-delay: 500ms;
    display: inline-block;
    border: 1px solid #ddd;
    width: 110px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    background: #fff;
    color: #592065;
  }

  #bilgin .most_product_inner {
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-evenly; */
  }

  .section-title-dk-blue {
    /* min-height: 50px; */
    margin: 5px 0;
  }
  .carousel__track {
    margin-bottom: 16px;
  }
</style>
